
import { Link, useNavigate } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      title: "Brand Strategy",
      description: "Developing comprehensive brand identities that reflect core values and connect with target audiences through strategic positioning.",
      icon: "ri-compass-3-line",
      link: "/work#project-highlights"
    },
    {
      title: "Visual Identity",
      description: "Creating cohesive visual systems including logos, typography, color palettes, and brand guidelines that ensure consistency.",
      icon: "ri-palette-line",
      link: "/work#visual-identity-systems"
    },
    {
      title: "Photography",
      description: "Professional photography services that capture the essence of brands through thoughtful composition and lighting.",
      icon: "ri-camera-line",
      link: "/photography"
    },
    {
      title: "Art Direction",
      description: "Guiding creative vision across all touchpoints to ensure brand consistency and impactful visual communication.",
      icon: "ri-eye-line",
      link: "/work#yaamava-interactive-activation"
    },
    {
      title: "Workflow Solutions",
      description: "Streamlining creative processes and developing efficient systems that enhance productivity and collaboration.",
      icon: "ri-flow-chart",
      link: null
    },
    {
      title: "Digital Design",
      description: "Designing user-centered digital experiences that translate brand values into engaging online interactions.",
      icon: "ri-computer-line",
      link: "/work"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Creative Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From concept to execution, I deliver comprehensive creative solutions 
            that elevate your brand and connect with your audience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            service.title === "Workflow Solutions" ? (
              <a 
                href="/work#workflow-solutions"
                className="group block bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/work');
                  setTimeout(() => {
                    const element = document.getElementById('workflow-solutions');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }, 100);
                }}
              >
                <div className="bg-gray-50 p-8 h-full transition-all duration-300 hover:bg-gray-100">
                  <div className="w-12 h-12 flex items-center justify-center bg-gray-900 text-white mb-6 group-hover:bg-gray-800 transition-colors">
                    <i className="ri-flow-chart text-xl"></i>
                  </div>
                  <h3 className="text-xl font-medium text-gray-900 mb-4">Workflow Solutions</h3>
                  <p className="text-gray-600 leading-relaxed mb-6">
                    Streamlining creative processes and developing efficient systems that enhance productivity and collaboration.
                  </p>
                  <div className="flex items-center text-gray-900 font-medium group-hover:text-teal-600 transition-colors duration-300">
                    <span className="whitespace-nowrap">Learn More</span>
                    <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
                  </div>
                </div>
              </a>
            ) : service.link ? (
              <Link
                key={index}
                to={service.link}
                className="group block bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
              >
                <div className="bg-gray-50 p-8 h-full transition-all duration-300 hover:bg-gray-100">
                  <div className="w-12 h-12 flex items-center justify-center bg-gray-900 text-white mb-6 group-hover:bg-gray-800 transition-colors">
                    <i className={`${service.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-xl font-medium text-gray-900 mb-4">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>
                  <div className="flex items-center text-gray-900 font-medium group-hover:text-teal-600 transition-colors duration-300">
                    <span className="whitespace-nowrap">Learn More</span>
                    <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
                  </div>
                </div>
              </Link>
            ) : null
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
